import { h, Component } from "preact";
import { push_ga_event } from "../../utils/ga";
import { gettext as _ } from "../../utils/i18n";

interface Props {
    content_type: string;
    id: number;
    quote: string;
    originator: string;
    page_url: string;
    networks: string[];
}

interface State {}

export default class ShareButton extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {};
    }

    open_share_window(e, network) {
        var url;
        if (network == "facebook") {
            url = this.get_facebook_url();
        } else if (network == "twitter") {
            url = this.get_twitter_url();
        } else if (network == "vkontakte") {
            url = this.get_vkontakte_url();
        }

        window.open(url, "_blank", "status=1,width=650,height=400,resizable=1");
        push_ga_event(this.props.content_type, network + " sharing", "#" + this.props.id);
    }

    get_quote_text(max_length?: number) {
        let text = this.props.quote + " — " + this.props.originator;

        if (max_length && text.length > max_length) {
            text = text.substring(0, max_length - 3) + "...";
        }

        return text;
    }

    // TODO: Abstraction for creating sharing URLs? (same logic live in ShareBar and js-share-popup)
    get_facebook_url() {
        const quote = this.props.quote + " — " + this.props.originator;
        return (
            "https://www.facebook.com/sharer/sharer.php?u=" +
            encodeURIComponent(this.props.page_url) +
            "&quote=" +
            encodeURIComponent(this.get_quote_text())
        );
    }

    get_vkontakte_url() {
        const quote = this.get_quote_text(130);
        return "http://vk.com/share.php?url=" + encodeURIComponent(this.props.page_url) + "&title=" + quote;
    }

    get_twitter_url() {
        const quote = this.get_quote_text(250);

        return (
            "https://twitter.com/intent/tweet?&url=" +
            encodeURIComponent(this.props.page_url) +
            "&text=" +
            encodeURIComponent(quote)
        );
    }

    render(props: Props, state: State) {
        const msg_titles = {
            vkontakte: _("Share on VK"),
            facebook: _("Share on Facebook"),
            twitter: _("Share on Twitter"),
        };

        return (
            <div>
                {props.networks.map((network_name) => (
                    <button
                        className="muted"
                        data-quote-share-action={network_name}
                        aria-label={msg_titles[network_name]}
                        onClick={(e) => this.open_share_window(e, network_name)}
                    >
                        <svg className="icon icon-filled">
                            <use xlinkHref={"#" + network_name} />
                        </svg>
                    </button>
                ))}
            </div>
        );
    }
}
